import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Divider, Form, Spin, Steps, Radio } from "antd";
import styled from "styled-components";
import { getProfileData, toggleSpinner, editCharityProfile, setEditCharityProfile, setCreateCharityProfile } from "../../redux/actions";
import StyledText from "../../components/StyledText";
import Button from "../../components/Button";
import CustomSelect from "../../components/CustomSelect";
import {
    toggleSpinnerSelector,
    profileSelector,
    editCharityProfileSelector
} from "../../redux/selectors";
import {
    useAppDispatch,
    useAppSelector
} from "../../redux/store";

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const getCountriesList = (intl) => {
    return [{ label: intl.formatMessage({ id: "country_af" }), value: "AF" },
    { label: intl.formatMessage({ id: "country_ax" }), value: "AX" },
    { label: intl.formatMessage({ id: "country_al" }), value: "AL" },
    { label: intl.formatMessage({ id: "country_dz" }), value: "DZ" },
    { label: intl.formatMessage({ id: "country_as" }), value: "AS" },
    { label: intl.formatMessage({ id: "country_ad" }), value: "AD" },
    { label: intl.formatMessage({ id: "country_ao" }), value: "AO" },
    { label: intl.formatMessage({ id: "country_ai" }), value: "AI" },
    { label: intl.formatMessage({ id: "country_aq" }), value: "AQ" },
    { label: intl.formatMessage({ id: "country_ag" }), value: "AG" },
    { label: intl.formatMessage({ id: "country_ar" }), value: "AR" },
    { label: intl.formatMessage({ id: "country_am" }), value: "AM" },
    { label: intl.formatMessage({ id: "country_aw" }), value: "AW" },
    { label: intl.formatMessage({ id: "country_au" }), value: "AU" },
    { label: intl.formatMessage({ id: "country_at" }), value: "AT" },
    { label: intl.formatMessage({ id: "country_az" }), value: "AZ" },
    { label: intl.formatMessage({ id: "country_bs" }), value: "BS" },
    { label: intl.formatMessage({ id: "country_bh" }), value: "BH" },
    { label: intl.formatMessage({ id: "country_bd" }), value: "BD" },
    { label: intl.formatMessage({ id: "country_bb" }), value: "BB" },
    { label: intl.formatMessage({ id: "country_by" }), value: "BY" },
    { label: intl.formatMessage({ id: "country_be" }), value: "BE" },
    { label: intl.formatMessage({ id: "country_bz" }), value: "BZ" },
    { label: intl.formatMessage({ id: "country_bj" }), value: "BJ" },
    { label: intl.formatMessage({ id: "country_bm" }), value: "BM" },
    { label: intl.formatMessage({ id: "country_bt" }), value: "BT" },
    { label: intl.formatMessage({ id: "country_bo" }), value: "BO" },
    { label: intl.formatMessage({ id: "country_bq" }), value: "BQ" },
    { label: intl.formatMessage({ id: "country_ba" }), value: "BA" },
    { label: intl.formatMessage({ id: "country_bw" }), value: "BW" },
    { label: intl.formatMessage({ id: "country_bv" }), value: "BV" },
    { label: intl.formatMessage({ id: "country_br" }), value: "BR" },
    { label: intl.formatMessage({ id: "country_io" }), value: "IO" },
    { label: intl.formatMessage({ id: "country_bn" }), value: "BN" },
    { label: intl.formatMessage({ id: "country_bg" }), value: "BG" },
    { label: intl.formatMessage({ id: "country_bf" }), value: "BF" },
    { label: intl.formatMessage({ id: "country_bi" }), value: "BI" },
    { label: intl.formatMessage({ id: "country_cv" }), value: "CV" },
    { label: intl.formatMessage({ id: "country_kh" }), value: "KH" },
    { label: intl.formatMessage({ id: "country_cm" }), value: "CM" },
    { label: intl.formatMessage({ id: "country_ca" }), value: "CA" },
    { label: intl.formatMessage({ id: "country_ky" }), value: "KY" },
    { label: intl.formatMessage({ id: "country_cf" }), value: "CF" },
    { label: intl.formatMessage({ id: "country_td" }), value: "TD" },
    { label: intl.formatMessage({ id: "country_cl" }), value: "CL" },
    { label: intl.formatMessage({ id: "country_cn" }), value: "CN" },
    { label: intl.formatMessage({ id: "country_cx" }), value: "CX" },
    { label: intl.formatMessage({ id: "country_cc" }), value: "CC" },
    { label: intl.formatMessage({ id: "country_co" }), value: "CO" },
    { label: intl.formatMessage({ id: "country_km" }), value: "KM" },
    { label: intl.formatMessage({ id: "country_cg" }), value: "CG" },
    { label: intl.formatMessage({ id: "country_cd" }), value: "CD" },
    { label: intl.formatMessage({ id: "country_ck" }), value: "CK" },
    { label: intl.formatMessage({ id: "country_cr" }), value: "CR" },
    { label: intl.formatMessage({ id: "country_ci" }), value: "CI" },
    { label: intl.formatMessage({ id: "country_hr" }), value: "HR" },
    { label: intl.formatMessage({ id: "country_cu" }), value: "CU" },
    { label: intl.formatMessage({ id: "country_cw" }), value: "CW" },
    { label: intl.formatMessage({ id: "country_cy" }), value: "CY" },
    { label: intl.formatMessage({ id: "country_cz" }), value: "CZ" },
    { label: intl.formatMessage({ id: "country_dk" }), value: "DK" },
    { label: intl.formatMessage({ id: "country_dj" }), value: "DJ" },
    { label: intl.formatMessage({ id: "country_dm" }), value: "DM" },
    { label: intl.formatMessage({ id: "country_do" }), value: "DO" },
    { label: intl.formatMessage({ id: "country_ec" }), value: "EC" },
    { label: intl.formatMessage({ id: "country_eg" }), value: "EG" },
    { label: intl.formatMessage({ id: "country_sv" }), value: "SV" },
    { label: intl.formatMessage({ id: "country_gq" }), value: "GQ" },
    { label: intl.formatMessage({ id: "country_er" }), value: "ER" },
    { label: intl.formatMessage({ id: "country_ee" }), value: "EE" },
    { label: intl.formatMessage({ id: "country_sz" }), value: "SZ" },
    { label: intl.formatMessage({ id: "country_et" }), value: "ET" },
    { label: intl.formatMessage({ id: "country_fk" }), value: "FK" },
    { label: intl.formatMessage({ id: "country_fo" }), value: "FO" },
    { label: intl.formatMessage({ id: "country_fj" }), value: "FJ" },
    { label: intl.formatMessage({ id: "country_fi" }), value: "FI" },
    { label: intl.formatMessage({ id: "country_fr" }), value: "FR" },
    { label: intl.formatMessage({ id: "country_gf" }), value: "GF" },
    { label: intl.formatMessage({ id: "country_pf" }), value: "PF" },
    { label: intl.formatMessage({ id: "country_tf" }), value: "TF" },
    { label: intl.formatMessage({ id: "country_ga" }), value: "GA" },
    { label: intl.formatMessage({ id: "country_gm" }), value: "GM" },
    { label: intl.formatMessage({ id: "country_ge" }), value: "GE" },
    { label: intl.formatMessage({ id: "country_de" }), value: "DE" },
    { label: intl.formatMessage({ id: "country_gh" }), value: "GH" },
    { label: intl.formatMessage({ id: "country_gi" }), value: "GI" },
    { label: intl.formatMessage({ id: "country_gr" }), value: "GR" },
    { label: intl.formatMessage({ id: "country_gl" }), value: "GL" },
    { label: intl.formatMessage({ id: "country_gd" }), value: "GD" },
    { label: intl.formatMessage({ id: "country_gp" }), value: "GP" },
    { label: intl.formatMessage({ id: "country_gu" }), value: "GU" },
    { label: intl.formatMessage({ id: "country_gt" }), value: "GT" },
    { label: intl.formatMessage({ id: "country_gg" }), value: "GG" },
    { label: intl.formatMessage({ id: "country_gn" }), value: "GN" },
    { label: intl.formatMessage({ id: "country_gw" }), value: "GW" },
    { label: intl.formatMessage({ id: "country_gy" }), value: "GY" },
    { label: intl.formatMessage({ id: "country_ht" }), value: "HT" },
    { label: intl.formatMessage({ id: "country_hm" }), value: "HM" },
    { label: intl.formatMessage({ id: "country_va" }), value: "VA" },
    { label: intl.formatMessage({ id: "country_hn" }), value: "HN" },
    { label: intl.formatMessage({ id: "country_hk" }), value: "HK" },
    { label: intl.formatMessage({ id: "country_hu" }), value: "HU" },
    { label: intl.formatMessage({ id: "country_is" }), value: "IS" },
    { label: intl.formatMessage({ id: "country_in" }), value: "IN" },
    { label: intl.formatMessage({ id: "country_id" }), value: "ID" },
    { label: intl.formatMessage({ id: "country_ir" }), value: "IR" },
    { label: intl.formatMessage({ id: "country_iq" }), value: "IQ" },
    { label: intl.formatMessage({ id: "country_ie" }), value: "IE" },
    { label: intl.formatMessage({ id: "country_im" }), value: "IM" },
    { label: intl.formatMessage({ id: "country_il" }), value: "IL" },
    { label: intl.formatMessage({ id: "country_it" }), value: "IT" },
    { label: intl.formatMessage({ id: "country_jm" }), value: "JM" },
    { label: intl.formatMessage({ id: "country_jp" }), value: "JP" },
    { label: intl.formatMessage({ id: "country_je" }), value: "JE" },
    { label: intl.formatMessage({ id: "country_jo" }), value: "JO" },
    { label: intl.formatMessage({ id: "country_kz" }), value: "KZ" },
    { label: intl.formatMessage({ id: "country_ke" }), value: "KE" },
    { label: intl.formatMessage({ id: "country_ki" }), value: "KI" },
    { label: intl.formatMessage({ id: "country_kp" }), value: "KP" },
    { label: intl.formatMessage({ id: "country_kr" }), value: "KR" },
    { label: intl.formatMessage({ id: "country_kw" }), value: "KW" },
    { label: intl.formatMessage({ id: "country_kg" }), value: "KG" },
    { label: intl.formatMessage({ id: "country_la" }), value: "LA" },
    { label: intl.formatMessage({ id: "country_lv" }), value: "LV" },
    { label: intl.formatMessage({ id: "country_lb" }), value: "LB" },
    { label: intl.formatMessage({ id: "country_ls" }), value: "LS" },
    { label: intl.formatMessage({ id: "country_lr" }), value: "LR" },
    { label: intl.formatMessage({ id: "country_ly" }), value: "LY" },
    { label: intl.formatMessage({ id: "country_li" }), value: "LI" },
    { label: intl.formatMessage({ id: "country_lt" }), value: "LT" },
    { label: intl.formatMessage({ id: "country_lu" }), value: "LU" },
    { label: intl.formatMessage({ id: "country_mo" }), value: "MO" },
    { label: intl.formatMessage({ id: "country_mg" }), value: "MG" },
    { label: intl.formatMessage({ id: "country_mw" }), value: "MW" },
    { label: intl.formatMessage({ id: "country_my" }), value: "MY" },
    { label: intl.formatMessage({ id: "country_mv" }), value: "MV" },
    { label: intl.formatMessage({ id: "country_ml" }), value: "ML" },
    { label: intl.formatMessage({ id: "country_mt" }), value: "MT" },
    { label: intl.formatMessage({ id: "country_mh" }), value: "MH" },
    { label: intl.formatMessage({ id: "country_mq" }), value: "MQ" },
    { label: intl.formatMessage({ id: "country_mr" }), value: "MR" },
    { label: intl.formatMessage({ id: "country_mu" }), value: "MU" },
    { label: intl.formatMessage({ id: "country_yt" }), value: "YT" },
    { label: intl.formatMessage({ id: "country_mx" }), value: "MX" },
    { label: intl.formatMessage({ id: "country_fm" }), value: "FM" },
    { label: intl.formatMessage({ id: "country_md" }), value: "MD" },
    { label: intl.formatMessage({ id: "country_mc" }), value: "MC" },
    { label: intl.formatMessage({ id: "country_mn" }), value: "MN" },
    { label: intl.formatMessage({ id: "country_me" }), value: "ME" },
    { label: intl.formatMessage({ id: "country_ms" }), value: "MS" },
    { label: intl.formatMessage({ id: "country_ma" }), value: "MA" },
    { label: intl.formatMessage({ id: "country_mz" }), value: "MZ" },
    { label: intl.formatMessage({ id: "country_mm" }), value: "MM" },
    { label: intl.formatMessage({ id: "country_na" }), value: "NA" },
    { label: intl.formatMessage({ id: "country_nr" }), value: "NR" },
    { label: intl.formatMessage({ id: "country_np" }), value: "NP" },
    { label: intl.formatMessage({ id: "country_nl" }), value: "NL" },
    { label: intl.formatMessage({ id: "country_nc" }), value: "NC" },
    { label: intl.formatMessage({ id: "country_nz" }), value: "NZ" },
    { label: intl.formatMessage({ id: "country_ni" }), value: "NI" },
    { label: intl.formatMessage({ id: "country_ne" }), value: "NE" },
    { label: intl.formatMessage({ id: "country_ng" }), value: "NG" },
    { label: intl.formatMessage({ id: "country_nu" }), value: "NU" },
    { label: intl.formatMessage({ id: "country_nf" }), value: "NF" },
    { label: intl.formatMessage({ id: "country_mk" }), value: "MK" },
    { label: intl.formatMessage({ id: "country_mp" }), value: "MP" },
    { label: intl.formatMessage({ id: "country_no" }), value: "NO" },
    { label: intl.formatMessage({ id: "country_om" }), value: "OM" },
    { label: intl.formatMessage({ id: "country_pk" }), value: "PK" },
    { label: intl.formatMessage({ id: "country_pw" }), value: "PW" },
    { label: intl.formatMessage({ id: "country_pa" }), value: "PA" },
    { label: intl.formatMessage({ id: "country_pg" }), value: "PG" },
    { label: intl.formatMessage({ id: "country_py" }), value: "PY" },
    { label: intl.formatMessage({ id: "country_pe" }), value: "PE" },
    { label: intl.formatMessage({ id: "country_ph" }), value: "PH" },
    { label: intl.formatMessage({ id: "country_pn" }), value: "PN" },
    { label: intl.formatMessage({ id: "country_pl" }), value: "PL" },
    { label: intl.formatMessage({ id: "country_pt" }), value: "PT" },
    { label: intl.formatMessage({ id: "country_pr" }), value: "PR" },
    { label: intl.formatMessage({ id: "country_qa" }), value: "QA" },
    { label: intl.formatMessage({ id: "country_ro" }), value: "RO" },
    { label: intl.formatMessage({ id: "country_ru" }), value: "RU" },
    { label: intl.formatMessage({ id: "country_rw" }), value: "RW" },
    { label: intl.formatMessage({ id: "country_re" }), value: "RE" },
    { label: intl.formatMessage({ id: "country_bl" }), value: "BL" },
    { label: intl.formatMessage({ id: "country_sh" }), value: "SH" },
    { label: intl.formatMessage({ id: "country_kn" }), value: "KN" },
    { label: intl.formatMessage({ id: "country_lc" }), value: "LC" },
    { label: intl.formatMessage({ id: "country_mf" }), value: "MF" },
    { label: intl.formatMessage({ id: "country_pm" }), value: "PM" },
    { label: intl.formatMessage({ id: "country_vc" }), value: "VC" },
    { label: intl.formatMessage({ id: "country_ws" }), value: "WS" },
    { label: intl.formatMessage({ id: "country_sm" }), value: "SM" },
    { label: intl.formatMessage({ id: "country_st" }), value: "ST" },
    { label: intl.formatMessage({ id: "country_sa" }), value: "SA" },
    { label: intl.formatMessage({ id: "country_sn" }), value: "SN" },
    { label: intl.formatMessage({ id: "country_rs" }), value: "RS" },
    { label: intl.formatMessage({ id: "country_sc" }), value: "SC" },
    { label: intl.formatMessage({ id: "country_sl" }), value: "SL" },
    { label: intl.formatMessage({ id: "country_sg" }), value: "SG" },
    { label: intl.formatMessage({ id: "country_sx" }), value: "SX" },
    { label: intl.formatMessage({ id: "country_sk" }), value: "SK" },
    { label: intl.formatMessage({ id: "country_si" }), value: "SI" },
    { label: intl.formatMessage({ id: "country_sb" }), value: "SB" },
    { label: intl.formatMessage({ id: "country_so" }), value: "SO" },
    { label: intl.formatMessage({ id: "country_za" }), value: "ZA" },
    { label: intl.formatMessage({ id: "country_gs" }), value: "GS" },
    { label: intl.formatMessage({ id: "country_ss" }), value: "SS" },
    { label: intl.formatMessage({ id: "country_es" }), value: "ES" },
    { label: intl.formatMessage({ id: "country_lk" }), value: "LK" },
    { label: intl.formatMessage({ id: "country_sd" }), value: "SD" },
    { label: intl.formatMessage({ id: "country_sr" }), value: "SR" },
    { label: intl.formatMessage({ id: "country_sj" }), value: "SJ" },
    { label: intl.formatMessage({ id: "country_se" }), value: "SE" },
    { label: intl.formatMessage({ id: "country_ch" }), value: "CH" },
    { label: intl.formatMessage({ id: "country_sy" }), value: "SY" },
    { label: intl.formatMessage({ id: "country_tw" }), value: "TW" },
    { label: intl.formatMessage({ id: "country_tj" }), value: "TJ" },
    { label: intl.formatMessage({ id: "country_tz" }), value: "TZ" },
    { label: intl.formatMessage({ id: "country_th" }), value: "TH" },
    { label: intl.formatMessage({ id: "country_tl" }), value: "TL" },
    { label: intl.formatMessage({ id: "country_tg" }), value: "TG" },
    { label: intl.formatMessage({ id: "country_tk" }), value: "TK" },
    { label: intl.formatMessage({ id: "country_to" }), value: "TO" },
    { label: intl.formatMessage({ id: "country_tt" }), value: "TT" },
    { label: intl.formatMessage({ id: "country_tn" }), value: "TN" },
    { label: intl.formatMessage({ id: "country_tr" }), value: "TR" },
    { label: intl.formatMessage({ id: "country_tm" }), value: "TM" },
    { label: intl.formatMessage({ id: "country_tv" }), value: "TV" },
    { label: intl.formatMessage({ id: "country_ug" }), value: "UG" },
    { label: intl.formatMessage({ id: "country_ua" }), value: "UA" },
    { label: intl.formatMessage({ id: "country_ae" }), value: "AE" },
    { label: intl.formatMessage({ id: "country_gb" }), value: "GB" },
    { label: intl.formatMessage({ id: "country_us" }), value: "US" },
    { label: intl.formatMessage({ id: "country_uy" }), value: "UY" },
    { label: intl.formatMessage({ id: "country_uz" }), value: "UZ" },
    { label: intl.formatMessage({ id: "country_vu" }), value: "VU" },
    { label: intl.formatMessage({ id: "country_ve" }), value: "VE" },
    { label: intl.formatMessage({ id: "country_vn" }), value: "VN" },
    { label: intl.formatMessage({ id: "country_eh" }), value: "EH" },
    { label: intl.formatMessage({ id: "country_ye" }), value: "YE" },
    { label: intl.formatMessage({ id: "country_zm" }), value: "ZM" },
    { label: intl.formatMessage({ id: "country_zw" }), value: "ZW" },
    ]
}

const CharityProfileLocations = ({ className }) => {
    const baseClassName = clsx("charityProfileLocations", className);
    const intl = useIntl();
    const [savedClicked, setSavedClicked] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const showSpinner = useAppSelector(toggleSpinnerSelector);
    const { charity: { ID = '', legalName, operatingLocation, nationallyActive } = {} } = useAppSelector(profileSelector) || {};

    const { message } = useAppSelector(editCharityProfileSelector) || {};

    const countries = getCountriesList(intl);

    useEffect(() => {
        if ((message) && !savedClicked) {
            dispatch(setEditCharityProfile(''))
            dispatch(setCreateCharityProfile(''))
            dispatch(toggleSpinner(false));
            navigate("/impact-maker/profile/create/description");
        }
    }, [message])

    useEffect(() => {
        if (legalName) {
            const data = {
                ...(operatingLocation && {
                    operatingLocation: operatingLocation?.map((location) => intl.formatMessage({ id: location }))
                }),
                ...(nationallyActive && { radioGroup: nationallyActive === 'Y' ? 'nationallyActive' : 'locallyActive' }),
            };
            form.setFieldsValue(data);
        }
    }, [legalName]);

    useEffect(() => {
        document.documentElement.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        dispatch(getProfileData());
    }, []);

    const onFinishFailed = (e) => {
        console.log("Failed:", e);
    };

    const handleProceed = (e) => {
        const formData = form.getFieldsValue();
        const { radioGroup, ...rest } = formData || {};
        const data = {
            ID,
            ...rest,
            operatingLocation: countries.filter((el) => formData?.operatingLocation?.includes(el.label))?.map((el) => `country_${el.value.toLocaleLowerCase()}`),
            nationallyActive: formData?.radioGroup === 'nationallyActive' ? 'Y' : 'N',
            locallyActive: formData?.radioGroup === 'locallyActive' ? 'Y' : 'N',
        }
        dispatch(editCharityProfile(data))
    }

    const handleSaveAndExit = () => {
        setSavedClicked(true);
        setTimeout(() => {
            form.submit();
            dispatch(toggleSpinner(false));
            navigate("/impact-maker/profile");
        }, 300);
    }

    const handlePrevious = () => {
        navigate("/impact-maker/profile/create/trustees")
    }

    return (
        <div className={baseClassName}>
            {showSpinner && (
                <div className="overlay">
                    <Spin className="spinner" size="large" spinning={showSpinner} />
                </div>
            )}
            <Steps
                current={2}
                items={[
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_1" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>
                            {intl.formatMessage({ id: "entity_details" })}
                        </StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_2" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3c" className='mainTitle'>
                            {intl.formatMessage({ id: "locations" })}
                        </StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_3" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>
                            {intl.formatMessage({ id: "contact_details" })}
                        </StyledText>,
                    }
                ]}
            />
            <div className='contentContainer'>
                <div>
                    <StyledText as="p" variant="H1" className='mainTitle'>
                        {intl.formatMessage({ id: "locations" })}
                    </StyledText>
                    <StyledText as="p" variant="B3d">
                        {intl.formatMessage({ id: "where_are_you_able_to_run_your_projects" })}
                    </StyledText>
                    <StyledText as="p" variant="B3" className='mainTitle'>
                        {intl.formatMessage({ id: "based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you" })}
                    </StyledText>
                    <Form
                        {...formItemLayout}
                        labelAlign="left"
                        onFinish={handleProceed}
                        onFinishFailed={onFinishFailed}
                        form={form}
                        className="formContainer"
                        scrollToFirstError
                    >
                        <div className="mainContentContainer">
                            <div className="contentContainer">
                                <Form.Item
                                    name="operatingLocation"
                                    rules={[{ required: true, message: 'Please select an option!' }]}
                                >
                                    <CustomSelect
                                        type="formSelect"
                                        name="category1"
                                        placeholder={intl.formatMessage({ id: "countries_of_operation" })}
                                        options={countries?.map((el) => ({ label: el.label, value: el.label }))}
                                        mode="multiple"
                                    />
                                </Form.Item>
                                <StyledText as="p" variant="B3d">
                                    {intl.formatMessage({ id: "within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only" })}
                                </StyledText>
                                <Form.Item
                                    name="radioGroup"
                                    rules={[{ required: true, message: 'Please select an option!' }]}
                                >
                                    <Radio.Group className='radioGroup'>
                                        <Radio value="nationallyActive">{intl.formatMessage({ id: "nationwide" })}</Radio>
                                        <Radio value="locallyActive">{intl.formatMessage({ id: "specific_locations_within_each_country" })}</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </div>
                            <div className="buttonContainer">
                                <Divider />
                                <div className="buttonContentContainer">
                                    <div className="nextAndPreviousContainer">
                                        <Button variant="secondary" type="button" onClick={() => handlePrevious()}>
                                            {intl.formatMessage({ id: "previous" })}
                                        </Button>
                                        <Button variant="primary" htmlType="submit">
                                            {intl.formatMessage({ id: "next" })}
                                        </Button>
                                    </div>
                                    <div className="saveAndExitButton">
                                        <Button variant="secondary" htmlType="button" onClick={() => handleSaveAndExit()}>
                                            {intl.formatMessage({ id: "save_n_exit" })}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>

                </div>
            </div>
        </div>
    )
}

const StyledCharityProfileLocations = styled(CharityProfileLocations)`
&.charityProfileLocations{
    background: white;
    display: flex;
    flex-direction: column;
    padding: 20px;
    justify-content: space-between;
    margin-top: 50px;
    .googlePlaceInputItem{
        width: 16vw;
    }
    .mainTitle{
        margin-bottom: 20px;
    }
    .errorText{
        color: #ff4d4f;
    }
    .radioGroup {
        display: flex;
        flex-direction: column;
    }
    .contentContainer{
        display: flex;
        flex-direction: column;
        gap: 12px;
        height: 100vh;
        .formContainer{
        display: flex;
        gap: 12px;
        flex-direction: column;
    }
    }
    .addButton{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .checkboxGroup{
        display: flex;
        flex-direction: column;
    }
    .optionsContainer{
        display: flex;
        align-items: center;
        gap: 30px;
        .for{
            margin-bottom: 10px;
        }
    }
    .overlay {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1000;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.45);
        }
    .spinner {
            z-index: 2000;
            margin: auto;
            left: 50%;
            right: 50%;
            position: absolute;
            bottom: 50%;
    }

    .radioGroup {
            display: flex;
            flex-direction: column;
    }

    .buttonContainer{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        position: fixed;
        width: 100%;
        bottom: 0px;
        background: white;
        margin-left: -100px;
        .buttonContentContainer{
            display: flex;
            justify-content: center;
            width: 100%;
            position: relative;
            .saveAndExitButton{
                position: absolute;
                right: 0;
                margin-bottom: 15px;
            }
            .nextAndPreviousContainer{
                display: flex;
                gap: 20px;
                margin-bottom: 15px;
            }
        }
    }
    .formItemTextField{
        .ant-form-item-control-input{
            width: 34.5vw !important;
        }
    }
    .formItemTextFieldPart{
        .ant-form-item-control-input{
            width: 16vw !important;
        } 
    }
    .helperText {
    color: #5271FF !important;
    font-weight: bold !important;
    margin-bottom: 0px !important;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .tipsContainer{
    background: #D7FEFB;
    border: 1px solid #04ac9c;
    padding: 20px;
    border-radius: 10px;
    width: max-content;
    height: max-content;
    .titleContainer {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        gap: 10px;
    }
  }
  .formItemInput{
    width: 300px;
  }
}`;

export default StyledCharityProfileLocations;
